import { Group, Select, Stack } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import type { EntityType } from '@repo/common/enums/entityType';
import { Button } from '@repo/foundations';
import { useRef, useState } from 'react';
import { createChangeRequest, type ISecodaEntity } from '../../api';
import { getFieldToUpdate } from '../../features/Inbox/utils/notifications';
import type { SecodaEntity } from '../../lib/models';
import MultiLineEditorTabs from '../CatalogView/TableView/selectors/MultiLineEditorSelector/MultiLineEditorTabs';

export interface IChangeRequestProps {
	entity: SecodaEntity | ISecodaEntity;
	close: () => void;
}

export function ChangeRequestModal({ entity, close }: IChangeRequestProps) {
	const [submitting, setSubmitting] = useState(false);

	// Determine which field to use based on entity type configuration
	const fieldToUpdate = getFieldToUpdate(entity.entity_type as EntityType);

	// Get the current value from the appropriate field
	const getCurrentValue = () => {
		if (fieldToUpdate === 'definition') {
			return entity.definition || '';
		}
		return entity.description || '';
	};

	const fieldValueRef = useRef<string>(getCurrentValue());

	const onSubmit = async () => {
		setSubmitting(true);
		await createChangeRequest({
			data: {
				entity: entity.id,
				changes: { [fieldToUpdate]: fieldValueRef.current ?? '' },
			},
		});
		setSubmitting(false);
		showNotification({
			title: 'Change request sent',
			message:
				'You will recieve a notification when an admin reviews the request',
			color: 'green',
		});
		close();
	};

	return (
		<Stack>
			<Select
				// These will be hardcoded since they don't change much between resources.
				value="Description"
				data={['Description']}
				required
				label="Field"
				placeholder="Select the field to change"
			/>
			<MultiLineEditorTabs
				placeholder="Enter the new description."
				charPress={undefined}
				defaultValue={getCurrentValue()}
				moveCaretToEnd={undefined}
				onChange={(value: string) => {
					fieldValueRef.current = value;
				}}
			/>
			<Group position="right" mt="md">
				<Button onClick={onSubmit} type="submit" loading={submitting}>
					Submit
				</Button>
			</Group>
		</Stack>
	);
}
